import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { DatePickerCore } from '../DatePicker.Core/DatePicker.Core.es.js';

const DatePickerSingle = /*#__PURE__*/ forwardRef(({ onChange, ...props }, ref)=>{
    return jsx(DatePickerCore, {
        onSingleChange: onChange,
        ...props,
        ref: ref
    });
});
DatePickerSingle.displayName = 'DatePicker.Single';

export { DatePickerSingle };
//# sourceMappingURL=DatePicker.Single.es.js.map
